// src/pages/SetupCompletePage.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import TopNav from "../components/TopNav";
import Footer from "../components/Footer";
import "../components/landing.css";

export default function SetupCompletePage() {
  const navigate = useNavigate();

  const [questionnairePath, setQuestionnairePath] = useState("");
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    let cancelled = false;

    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate("/login", { replace: true });
        return;
      }

      try {
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        const userData = userSnap.exists() ? userSnap.data() : {};

        const sector = userData?.profile?.sector?.trim();

        if (cancelled) return;

        if (!sector) {
          navigate("/onboarding", { replace: true });
          return;
        }

        setQuestionnairePath(
          `/questionnaire/${encodeURIComponent(sector)}`
        );
      } catch (error) {
        console.error("[SetupCompletePage] Unable to load sector:", error);

        if (!cancelled) {
          setErr(
            "We could not prepare your assessment link. Please return to your dashboard and try again."
          );
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    });

    return () => {
      cancelled = true;
      unsubscribeAuth();
    };
  }, [navigate]);

  return (
    <div className="landing" style={{ alignItems: "stretch" }}>
      <TopNav />

      <main
        className="landing__main"
        style={{
          maxWidth: 760,
          width: "100%",
          paddingTop: 100,
          textAlign: "center",
        }}
      >
        <section
          className="card"
          style={{
            background: "#FFFFFF",
            border: "1px solid #E2E8F0",
            borderRadius: 20,
            padding: "42px 28px",
            boxShadow: "0 12px 30px rgba(15, 23, 42, 0.08)",
          }}
        >
          <div
            style={{
              width: 62,
              height: 62,
              borderRadius: "999px",
              margin: "0 auto 20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#ECFDF5",
              color: "#047857",
              fontSize: 30,
              fontWeight: 700,
            }}
          >
            ✓
          </div>

          <p
            style={{
              margin: "0 0 10px",
              color: "#148A58",
              fontSize: 13,
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
            }}
          >
            Setup completed
          </p>

          <h1
            className="landing__title"
            style={{
              color: "#111827",
              fontSize: 32,
              margin: "0 0 14px",
            }}
          >
            Your profile is ready
          </h1>

          <p
            className="landing__subtitle"
            style={{
              color: "#64748B",
              fontSize: 16,
              lineHeight: 1.7,
              maxWidth: 560,
              margin: "0 auto 34px",
            }}
          >
            Your EcoTrack assessment has been configured for your business
            profile. You can begin your first ESG self-assessment now, or
            return later whenever you are ready.
          </p>

          <div
            style={{
              display: "flex",
              gap: 12,
              justifyContent: "center",
              flexWrap: "wrap",
              marginBottom: err ? 18 : 28,
            }}
          >
            {questionnairePath ? (
              <Link className="btn btn--primary" to={questionnairePath}>
                Start your first assessment
              </Link>
            ) : (
              <button
                type="button"
                className="btn btn--primary"
                disabled
              >
                {loading ? "Preparing assessment…" : "Start your first assessment"}
              </button>
            )}

            <Link className="btn btn--ghost" to="/dashboard">
              Start later
            </Link>
          </div>

          {err && (
            <p
              style={{
                color: "#B91C1C",
                fontSize: 14,
                lineHeight: 1.6,
                margin: "0 auto 28px",
                maxWidth: 560,
              }}
            >
              {err}
            </p>
          )}

          <div
            style={{
              maxWidth: 570,
              margin: "0 auto",
              padding: "16px 18px",
              background: "#F3F7F4",
              borderLeft: "4px solid #148A58",
              borderRadius: 10,
              textAlign: "left",
            }}
          >
            <p
              style={{
                margin: 0,
                color: "#475569",
                fontSize: 13,
                lineHeight: 1.65,
              }}
            >
              <strong style={{ color: "#103D33" }}>Note:</strong> Your
              assessment can be completed at your own pace. Any available
              progress-saving or resume functionality already present in
              EcoTrack will continue to apply once you start.
            </p>
          </div>
        </section>

        <Footer />
      </main>
    </div>
  );
}